import MessageTemplateList from "invitationTemplate/list/app";
import {
  type RouteObject,
} from "react-router";
import MessageTemplateDetail from "../../invitationTemplate/detail/app";

declare let viewModel: any;

export const messageTemplateRoute: RouteObject = {
  path: "template/message",
  children: [{
    path: ":type",
    loader: () => viewModel,
    Component: MessageTemplateList,
  }, {
    path: "detail/:key",
    loader: () => viewModel,
    Component: MessageTemplateDetail,
  }]
};